import { MessageBox, PerformanceChart, ProjectionChart, Space } from '@/components/core-v2'

import { useAppSelector } from '../../../store/hooks'

const ChartsDetailsSummary = () => {
  const state = useAppSelector(state => state.portfolio)
  const performanceMetrics =
    state?.portfolioType === 'ModelPortfolio'
      ? state?.model?.performanceMetrics
      : state?.selfSelect?.performanceMetrics
  const projection =
    state?.portfolioType === 'ModelPortfolio'
      ? state?.model?.projection
      : state?.selfSelect?.projection
  return (
    <>
      {(state.model || state.selfSelect) && (
        <Space my={3}>
          {performanceMetrics && (
            <PerformanceChart
              isError={false}
              isLoading={false}
              metrics={performanceMetrics}
              title="Historical performance (portfolio)"
            />
          )}
          {projection && (
            <ProjectionChart
              isError={false}
              isLoading={false}
              metrics={projection}
              title="Projections (portfolio)"
            />
          )}
        </Space>
      )}
      {state.model === undefined && state.selfSelect === undefined && (
        <Space mx={5} my={6}>
          <MessageBox state="warning" title="Portfolio charts do not yet exist for this trade">
            Please edit the trade and add a portfolio
          </MessageBox>
        </Space>
      )}
    </>
  )
}

export default ChartsDetailsSummary
